import React, { useState, useEffect } from 'react';

const RotatingText = ({ phrases, interval = 3000, className = '' }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setInterval(() => {
      setIsVisible(false);
      
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % phrases.length);
        setIsVisible(true);
      }, 300); // Fade out duration
    }, interval);

    return () => clearInterval(timer);
  }, [phrases.length, interval]);

  return (
    <div className={`rotating-text ${className}`}>
      <h2 
        className={`rotating-phrase ${isVisible ? 'visible' : 'hidden'}`}
        style={{
          fontSize: '2.5rem',
          fontWeight: 800,
          color: '#ffffff',
          margin: '0 0 20px 0',
          textAlign: 'center',
          textShadow: '0 4px 8px rgba(0,0,0,0.6)',
          transition: 'all 0.3s ease-in-out',
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
        }}
      >
        {phrases[currentIndex]}
      </h2>
    </div>
  );
};

export default RotatingText;
